/**
 * Native wishlist replacement -- localStorage-based, no account/app dependency, mirrors the
 * model-comparison.js pattern (same storage-key style, same fetch+DOMParser render approach).
 */
(function () {
  var STORAGE_KEY = "cryonosWishlist";
  var MAX_ITEMS = 50;

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    updateAllButtons();
    updateHeaderCount();
    document.dispatchEvent(new CustomEvent("wishlist:change", { detail: { list: list } }));
  }

  /* A55/A56 (04.10.2026): optional variant and quantity per saved product (key "cryonosWishlistMeta"),
     the list itself stays a list of handles (compatible with everything that reads it). */
  var META_KEY = "cryonosWishlistMeta";
  function getMeta() {
    try { var m = JSON.parse(localStorage.getItem(META_KEY) || "{}"); return m && typeof m === "object" ? m : {}; } catch (e) { return {}; }
  }
  function setMeta(m) { try { localStorage.setItem(META_KEY, JSON.stringify(m)); } catch (e) {} }
  function saveMany(entries) {
    var list = getWishlist();
    var meta = getMeta();
    var n = 0;
    entries.forEach(function (en) {
      if (!en || !en.handle) return;
      if (list.indexOf(en.handle) === -1) list.unshift(en.handle);
      var m = meta[en.handle] || {};
      if (en.variant) m.v = String(en.variant);
      if (en.qty) m.q = Math.max(1, parseInt(en.qty, 10) || 1);
      meta[en.handle] = m;
      n++;
    });
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    setMeta(meta);
    setWishlist(list);
    if (window.cryonosTrack) entries.forEach(function (en) { if (en && en.handle) window.cryonosTrack("watchlist_add", { item_id: en.handle }); });
    return n;
  }
  function snapshot() { return { list: getWishlist(), meta: getMeta() }; }
  function restore(snap) { if (!snap) return; setMeta(snap.meta || {}); setWishlist(snap.list || []); }
  function clearAll() { var s = snapshot(); setMeta({}); setWishlist([]); return s; }

  function isSaved(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.unshift(handle);
      if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    } else {
      list.splice(idx, 1);
      var meta = getMeta();
      if (meta[handle]) { delete meta[handle]; setMeta(meta); }
    }
    setWishlist(list);
    // Analytics (Buendel E, 30.09.2026): only adding is measured; item_id = public product handle.
    if (idx === -1 && window.cryonosTrack) window.cryonosTrack("watchlist_add", { item_id: handle });
    return idx === -1;
  }

  function updateAllButtons() {
    var list = getWishlist();
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-wishlist-toggle");
      var saved = list.indexOf(handle) !== -1;
      btn.classList.toggle("is-saved", saved);
      btn.setAttribute("aria-pressed", saved ? "true" : "false");
      var label = saved ? btn.getAttribute("data-label-remove") : btn.getAttribute("data-label-add");
      if (label) btn.setAttribute("aria-label", label);
    });
  }

  function updateHeaderCount() {
    var count = getWishlist().length;
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* Bugjagd 06.10.2026 (Blocker Merkliste): sitzt das Herz auf einer Produktseite mit Kaufformular (alte Vorlage,
     v60-Ersatzteilseite), wird die dort gewählte Variante und Menge mitgemerkt – wie beim v60-Geräte-Herz (A56). */
  function pageChoice(btn) {
    var sec = btn.closest(".shopify-section") || document;
    var idInput = sec.querySelector("[data-variant-id-input]");
    if (!idInput || !idInput.value) return null;
    var form = idInput.form;
    var qtyInput = (form && form.id && document.querySelector('input[name="quantity"][form="' + form.id + '"]')) || (form && form.querySelector('input[name="quantity"]')) || sec.querySelector('input[name="quantity"]');
    return { variant: idInput.value, qty: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1 };
  }
  /* H-361 (06.10.2026): Menge je gemerktem Produkt ändern, ohne die gemerkte Ausführung anzufassen. */
  function setQty(handle, qty) {
    var meta = getMeta(); var m = meta[handle] || {};
    m.q = Math.max(1, parseInt(qty, 10) || 1);
    meta[handle] = m; setMeta(meta);
  }
  function setVariant(handle, variant, qty) {
    var meta = getMeta(); var m = meta[handle] || {};
    if (variant) m.v = String(variant); else delete m.v;
    if (qty) m.q = Math.max(1, parseInt(qty, 10) || 1);
    meta[handle] = m; setMeta(meta);
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute("data-wishlist-toggle");
    var choice = !isSaved(handle) ? pageChoice(btn) : null;
    if (choice) setVariant(handle, choice.variant, choice.qty);
    toggle(handle);
  });

  document.addEventListener("DOMContentLoaded", function () {
    updateAllButtons();
    updateHeaderCount();
  });
  if (document.readyState !== "loading") {
    updateAllButtons();
    updateHeaderCount();
  }

  /*
   * Welle 4 (O7, 30.09.2026): "Compare all" on the watchlist page hands the FIRST `max` saved
   * handles (default 4, the limit of sections/model-comparison.liquid) to the comparison list
   * "cryonosCompare". Runs only on the visitor's click. Replaces the current comparison list.
   * set([]) ("Clear wishlist") stays available here; the page no longer shows a button for it.
   */
  function toCompare(max) {
    var picked = getWishlist().slice(0, max || 4);
    if (!picked.length) return picked;
    try { localStorage.setItem("cryonosCompare", JSON.stringify(picked)); } catch (e) {}
    return picked;
  }

  window.cryonosWishlist = { get: getWishlist, isSaved: isSaved, toggle: toggle, set: setWishlist, toCompare: toCompare, meta: getMeta, saveMany: saveMany, setVariant: setVariant, setQty: setQty, snapshot: snapshot, restore: restore, clear: clearAll };
})();
